import React, { memo } from 'react';
import { Wrapper, MainWrapper } from './Container.Styles';
import { BlockSection } from '../../../ModuleBlock';
export var PageContainer = memo(function () { return (React.createElement(React.Fragment, null,
    React.createElement(Wrapper, { id: "Container" },
        React.createElement(BlockSection, { id: "top" }),
        React.createElement(MainWrapper, null,
            React.createElement(BlockSection, { id: "left" }),
            React.createElement(BlockSection, { id: "main" }),
            React.createElement(BlockSection, { id: "right" })),
        React.createElement(BlockSection, { id: "bottom" })))); });
